export { getPrimaryOutputHandleId } from './getPrimaryOutputHandleId'
